import * as React from 'react';
import { antGrey, runwayColors, tagStyle } from './styles/globalStyles';

const OTATag: React.FC = () => {
    return (
        <div
            style={{
                ...tagStyle,
                backgroundColor: runwayColors.info,
                borderStyle: 'solid',
                borderColor: antGrey.grey1,
                borderWidth: 2,
                borderRadius: 36,
                color: 'white',
                fontSize: 18,
                fontWeight: 500,
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 4,
                paddingBottom: 4,
                marginBottom: 10,
            }}
        >
            OTA
        </div>
    );
};

export default OTATag;
